import React from 'react';
import PropTypes from 'prop-types';

import { WidgetReleaseWithRedactor } from 'components/common/Elements/Elements';

const ResponsReleaseBlock = ({
  data,
  onCancel,
  headerText,
  onClickOk,
  nameInput,
  newClearRelease,
  disabledBottomPanel,
  onClickEdit
}) => {
  return (
    <WidgetReleaseWithRedactor
      date={data.date}
      sourse={data.articleUrl}
      title={data.articleTitle}
      text={data.articleText}
      onCancel={onCancel}
      headerText={headerText}
      onClickOk={onClickOk}
      nameInput={nameInput}
      newClearRelease={newClearRelease}
      disabledBottomPanel={disabledBottomPanel}
      onClickEdit={onClickEdit}
    />
  );
};

ResponsReleaseBlock.propTypes = {
  date: PropTypes.string,
  title: PropTypes.string,
  sourse: PropTypes.string,
  text: PropTypes.string,
  onCancel: PropTypes.func,
  headerText: PropTypes.string,
  onClickOk: PropTypes.func,
  nameInput: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  newClearRelease: PropTypes.bool,
  disabledBottomPanel: PropTypes.bool,
  onClickEdit: PropTypes.func
};

export default ResponsReleaseBlock;
